import React, { useEffect, useState } from 'react';

import { Home } from './pages/home';
import { HealthInfo } from './pages/healthInfo';
import { TermsOfServiceInfo } from './pages/termsOfServiceInfo';
import { PolicyPrivacyInfo } from './pages/policyPrivacyInfo';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { ModalContext } from './contexts/modal.context';
import { useTranslation } from 'react-i18next';
import CookieBanner from './components/cookieBanner';


function App() {
  const { t, i18n } = useTranslation();
  const [modalContent, setModalContent] = useState<React.JSX.Element | null>(null);

  useEffect(() => {
    document.title = t("app.title", "Insulimit | sweeten health");

    const metaDescription = document.querySelector('meta[name="description"]');
    const descriptionContent = t("app.description", "Take control of your diabetes with Insulimit - the smart mobile app for tracking blood sugar, medication, and diet. Stay on top of your health with intuitive insights, reminders, and personalized analytics. Start managing your diabetes with ease today!");

    if (metaDescription) {
      metaDescription.setAttribute("content", descriptionContent);
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = "description";
      newMeta.content = descriptionContent;
      document.head.appendChild(newMeta);
    }
  }, [i18n.language, t]);


  return (
    <ModalContext.Provider value={{ modalContent, setModalContent }}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />}/>
          <Route path="/tos" element={<TermsOfServiceInfo />}/>
          <Route path="/privacy" element={<PolicyPrivacyInfo />}/>
          <Route path="/health_info" element={<HealthInfo />}/>
        </Routes>
        <CookieBanner />
      </Router>
      <CookieBanner />
    </ModalContext.Provider>
  );
}

export default App;
